import { useState } from "react";
import { Loading } from "@/components/Chrome";
import { adminLogin, useAdminSession } from "@/lib/store";

/**
 * 主辦人門禁：通關碼只存在 server 環境變數 ADMIN_CODE，
 * 由 /api/admin/session 驗證後發 HttpOnly session cookie——前端拿不到、也偽造不了。
 */
export function AdminGate({ children }: { children: React.ReactNode }) {
  const session = useAdminSession();
  const [input, setInput] = useState("");
  const [wrong, setWrong] = useState(false);
  const [busy, setBusy] = useState(false);

  if (session === undefined) return <Loading />;
  if (session) return <>{children}</>;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy || !input) return;
    setBusy(true);
    const ok = await adminLogin(input);
    setBusy(false);
    if (!ok) {
      setWrong(true);
      setInput("");
    }
  };

  return (
    <div className="card mx-auto mt-14 max-w-sm px-6 py-10 text-center">
      <div className="text-[34px]">🔐</div>
      <h2 className="mt-2 text-[20px] font-bold">主辦人專區</h2>
      <p className="text-sub mt-1 text-[13px]">請輸入通關碼</p>
      <form onSubmit={submit} className="mt-6 flex flex-col gap-3">
        <input
          type="password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="field-input text-center text-[18px] tracking-[0.4em]"
          placeholder="••••"
          autoFocus
        />
        {wrong && <p className="text-bad-deep text-[13px]">通關碼錯誤，請再試一次</p>}
        <button type="submit" disabled={busy} className="btn btn-primary">
          UNLOCK 解鎖
        </button>
      </form>
      <p className="text-sub mt-4 text-[11px] leading-relaxed">
        通關碼由主辦人設定（部署環境變數 ADMIN_CODE）
      </p>
    </div>
  );
}
